var app = angular.module("leonardo");

var TaskResolveConflictsDialog = function($scope, UserService) {
  $scope.conflicts = $scope.ngDialogData.conflicts;
  $scope.task = $scope.ngDialogData.task;
  $scope.userService = UserService;
  $scope.data = {};

  $scope.submit = function () {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    $scope.confirm($scope.data);
  }

};

app.controller('TaskResolveConflictsDialog', ['$scope', 'UserService', TaskResolveConflictsDialog]);
